import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { LayoutCard } from '@beef/landing-constructor';
import { compose } from '@beef/utils';
import { NText } from '@fttb/common/components';
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { getAdditionalServicesContent } from "../../store/blocks/servicesCards/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
var _AdditionalServicesBlock = function _AdditionalServicesBlock(_ref) {
  var className = _ref.className,
    content = _ref.content;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-AdditionalServicesBlock"
  }, /*#__PURE__*/React.createElement(LayoutCard, _extends({
    type: "infoCard"
  }, content)), content.footnote && /*#__PURE__*/React.createElement(NText, {
    className: "mar-t-2xl",
    color: "grey60",
    isInline: false,
    size: "size6-m"
  }, content.footnote));
};
var _AdditionalServicesBlockHOC = withAnalyticsOnBlockView(_AdditionalServicesBlock);
var mapStateToProps = function mapStateToProps(state) {
  return {
    analyticBlockTitle: getAdditionalServicesContent(state).title,
    content: getAdditionalServicesContent(state),
    pageType: getAnalyticEventType(state)
  };
};
var connector = connect(mapStateToProps);
export var AdditionalServicesBlock = compose(connector, defineBlock(FttbBlocks.ADDITIONAL_SERVICES))(_AdditionalServicesBlockHOC);